module.exports = __webpack_public_path__ + "img/icon-home.32f60fe5.svg";